/**
 * KnowledgeBaseService
 * CRUD for KnowledgeBase top-level containers.
 * Route: api/knowledge-bases
 */
import { BaseService } from '../base/BaseService';
/** Default empty audience used when the API returns nothing parseable. */
const EMPTY_AUDIENCE = { roleNames: [], ministryIds: [], departmentIds: [] };
export class KnowledgeBaseService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? KnowledgeBaseService.DEFAULT_SERVICE_PATH,
            basePath: KnowledgeBaseService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    getAllRaw() {
        return this.http.get(this.buildUrl(''));
    }
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    getByIdRaw(id) {
        return this.http.get(this.buildUrl(`${id}`));
    }
    async getByMinistry(ministryId) {
        const response = await this.getByMinistryRaw(ministryId);
        return response.data ?? [];
    }
    getByMinistryRaw(ministryId) {
        return this.http.get(this.buildUrl(`by-ministry/${ministryId}`));
    }
    async create(item) {
        const response = await this.createRaw(item);
        return response.data ?? null;
    }
    createRaw(item) {
        return this.http.post(this.buildUrl(''), item);
    }
    async update(id, item) {
        const response = await this.updateRaw(id, item);
        return response.data ?? null;
    }
    updateRaw(id, item) {
        return this.http.put(this.buildUrl(`${id}`), item);
    }
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    deleteRaw(id) {
        return this.http.delete(this.buildUrl(`${id}`));
    }
    // ============================================================
    // Visibility — audience management (Restricted KBs only)
    // ============================================================
    /**
     * Read the role/ministry/department audience grants for a Restricted KB.
     * Empty lists == visible to all signed-in users.
     */
    async getAudience(knowledgeBaseId) {
        const response = await this.getAudienceRaw(knowledgeBaseId);
        return response.data ?? { ...EMPTY_AUDIENCE };
    }
    getAudienceRaw(knowledgeBaseId) {
        return this.http.get(this.buildUrl(`${knowledgeBaseId}/audience`));
    }
    /** Wholesale replace a knowledge base's audience grants. */
    async setAudience(knowledgeBaseId, audience) {
        const response = await this.setAudienceRaw(knowledgeBaseId, audience);
        return response.data ?? audience;
    }
    setAudienceRaw(knowledgeBaseId, audience) {
        return this.http.put(this.buildUrl(`${knowledgeBaseId}/audience`), audience);
    }
}
KnowledgeBaseService.DEFAULT_SERVICE_PATH = 'resources';
KnowledgeBaseService.BASE_PATH = 'api/knowledge-bases';
//# sourceMappingURL=KnowledgeBaseService.js.map